import React, { useState } from "react";
import styled from "styled-components";
import { SubheadLg } from "storybook-components/Typography";

const FeedbackBox = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.green1};
  margin: 32px 0;
  padding: 32px 0;
`;

const QuerstionText = styled(SubheadLg)`
  margin: auto 16px auto 0;
  color: ${({ theme }) => theme.colors.green5};
`;

const FeedbackButton = styled.button`
  outline: none;
  border: none;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.green4};
  margin: 0 6px;
  padding: 5px 18px;
  cursor: pointer;
`;

const ArticleFeedback = () => {
  const [feedbackGiven, setFeedbackGiven] = useState(false);
  const trackFeedback = isHelpful => {
    if (typeof window !== `undefined` && window.analytics) {
      window.analytics.track("help-site-article-helpful", {
        isHelpful: isHelpful
      });
      setFeedbackGiven(true);
    }
  };
  return (
    <FeedbackBox>
      {feedbackGiven ? 
      <QuerstionText>Thanks! We appreciate your feedback.</QuerstionText>
      :
      <>
      <QuerstionText>Was this article helpful?</QuerstionText>
      <FeedbackButton onClick={() => trackFeedback(true)}><span role="img" aria-label="thumbs up">&#128077;</span></FeedbackButton>
      <FeedbackButton onClick={() => trackFeedback(false)}><span role="img" aria-label="thumbs down">&#128078;</span></FeedbackButton>
      </>
      }
    </FeedbackBox>
  );
};

ArticleFeedback.defaultProps = {
  type: "tip"
};

export default ArticleFeedback;
